import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RotateOverlay from './components/RotateOverlay';
import { setBackButtonUrl } from '../../store/uiSlice';
import { fetchLeaderboard, formatDisplayMMSS, parseHMS } from '../../utils/sopGame';
import './thankyou.css';

function formatLeaderboardTime(timee) {
  if (!timee) return '00:00';
  const parts = String(timee).split(':');
  if (parts.length === 2) return timee;
  return formatDisplayMMSS(parseHMS(timee));
}

export default function LeaderboardPage() {
  const user = useSelector((s) => s.auth.user);
  const dispatch = useDispatch();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(setBackButtonUrl('/thank-you'));
  }, [dispatch]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchLeaderboard(user);
        if (!cancelled) setEntries(res.entries || []);
      } catch (err) {
        console.error(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user]);

  return (
    <div className="sop-leaderboard">
      <RotateOverlay />
      <h1>Leaderboard</h1>
      {loading ? (
        <div className="sop-game-loader" />
      ) : (
        <table>
          <thead>
            <tr>
              <th>No.</th>
              <th>Name</th>
              <th>Score</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={`${e.rank}-${e.name}`}>
                <td>{e.rank}</td>
                <td>{e.name}</td>
                <td>{e.points}</td>
                <td>{formatLeaderboardTime(e.timee)}</td>
              </tr>
            ))}
            {!entries.length ? (
              <tr>
                <td colSpan={4}>No scores yet</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      )}
    </div>
  );
}
